module.exports = __webpack_public_path__ + "img/icono_votacion.0497a135.svg";